/**
 * Deep-linking de notificaciones: dado un type + data payload, devuelve
 * la ruta del SPA a la que llevar al user al hacer click. Devolver null
 * para tipos sin destino claro (el click no navega; solo marca leído).
 *
 * Convenciones del payload (definidas por los callers en backend):
 *  - absence_*: data.absence_id, data.employee_profile_id
 *  - document_requested: data.request_id, data.category_id
 *  - document_request_fulfilled: data.request_id, data.document_id
 *
 * @param {object} notification  fila de /notifications
 * @param {{ employeeProfileId: string|null }} ctx  contexto del current user
 * @returns {string|null}
 */
export function routeForNotification(notification, ctx = {}) {
  const type = notification?.type;
  const data = notification?.data || {};
  const myProfileId = ctx.employeeProfileId || null;

  switch (type) {
    case "absence_requested":
      // Notif → aprobador. Va a la bandeja de solicitudes.
      return "/solicitudes";

    case "absence_approved":
    case "absence_rejected":
      // Notif → solicitante. Va a su área de ausencias.
      return "/ausencias";

    case "absence_cancelled":
      // Esta puede llegar al aprobador (si canceló el empleado) o al
      // empleado (si canceló un manager). Lo distinguimos por si el
      // employee_profile_id del payload coincide con el mío.
      if (myProfileId && data.employee_profile_id === myProfileId) {
        return "/ausencias";
      }
      return "/solicitudes";

    case "document_requested":
      // Notif → empleado al que se le piden documentos.
      return "/mis-documentos";

    case "document_request_fulfilled":
      // Notif → manager que solicitó. Va a la vista de gestión.
      return "/documentos";

    case "overtime_requested":
      // Notif → aprobador. Va a la bandeja de solicitudes.
      return "/solicitudes";

    case "overtime_approved":
    case "overtime_rejected":
      // Notif → solicitante. Va a sus solicitudes.
      return "/mis-solicitudes";

    case "overtime_cancelled":
      // Puede llegar al aprobador (canceló el empleado) o al empleado
      // (canceló un manager). Distinguimos por el employee_profile_id.
      if (myProfileId && data.employee_profile_id === myProfileId) {
        return "/mis-solicitudes";
      }
      return "/solicitudes";

    case "workday_correction_requested":
    case "workday_correction_approved":
    case "workday_correction_rejected":
    case "workday_correction_cancelled":
      return "/jornada/historial";

    // La solicitud va al que aprueba (RRHH); la decisión, al empleado.
    case "special_schedule_requested":
      return "/rrhh/jornadas";
    case "special_schedule_approved":
    case "special_schedule_rejected":
      return "/jornada/historial";

    case "shift_approaching_limit":
    case "shift_limit_reached":
      return "/jornada";

    case "workday_incident_reported":
    case "workday_incident_validated":
      return "/jornada/historial";

    case "overtime_no_authorization":
      return "/jornada";

    case "report_ready":
    case "report_failed":
      return "/reportes";

    default:
      return null;
  }
}
